import React from 'react'

const ResourcePhone = () => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 25 24'
      width='25'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.492 9.514a2.006 2.006 0 000-2.83L6.37 4.563a2 2 0 00-2.828 0L2.378 5.727A3 3 0 002 9.5a46.535 46.535 0 0013 13 3 3 0 003.774-.379l1.164-1.164a2 2 0 000-2.828l-2.122-2.119a2.002 2.002 0 00-2.829 0l-.707.707a47.378 47.378 0 01-6.5-6.5l.712-.703z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M16.5 1h8M16.5 5h8M16.5 9h8M13.5 1h1M13.5 5h1M13.5 9h1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ResourcePhone
